import { gql } from "@apollo/client";

export const GET_CALIFICACION_MONITOREO = gql`
  query getCalificacionMonitoreo {
    claseMonitoreo {
      idClaseMonitoreo
      descripcion
    }
  }
`;